import api from './apiService';

export const login = async (email, password) => {
    try {        
        const response = await api.post('/login', {
            "email": email, 
            "password": password
        })

        const { access_token } = response.data || {};

        if (access_token) {
            localStorage.setItem('token', access_token);
            localStorage.setItem('loggedUser', JSON.stringify(response.data.user));
        }

        return response.data.user;
    } catch (error) {
        throw error.response.data;
    }
};

export const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('loggedUser')
}